import React, { useState } from "react";
import { useGlobalStore } from "@/store/hooks";
import { message, Input, Spin } from "antd";
import { CopyOutlined, EditOutlined } from "@ant-design/icons";
import copy from "copy-to-clipboard";
import { observer } from "mobx-react-lite";
import { useRequest } from "ahooks";
import { Panel } from "@/components";
import { getCompany, updateCompany } from "@/services/api/company";

interface SupplierInfoProps {}

const SupplierInfo: React.FC<SupplierInfoProps> = () => {
    const { currentUser, companyId } = useGlobalStore();
    const [edit, setEdit] = useState(false);
    const { data: company, mutate } = useRequest(() => {
        return getCompany(companyId);
    });

    const { runAsync: updateCompanyName, loading } = useRequest(
        async (e) => {
            const { value } = e.target;

            if (value && value !== company.name) {
                const newCompany = await updateCompany({
                    name: value,
                });

                mutate(newCompany);

                message.success("修改成功");
            }

            setEdit(false);
        },
        { manual: true },
    );

    const handleCopy = () => {
        copy(String(companyId));

        message.success("复制成功");
    };

    return (
        <Panel title="供货商账号信息" className="mb10">
            <Spin spinning={loading}>
                <div className="p20">
                    <div className="flex flex-center">
                        <div>
                            {edit ? (
                                <Input
                                    defaultValue={company?.name}
                                    autoFocus
                                    size="middle"
                                    style={{ maxWidth: "100px" }}
                                    className=" ml10 mr10"
                                    maxLength={24}
                                    onPressEnter={updateCompanyName}
                                    onBlur={() => {
                                        setEdit(false);
                                    }}
                                />
                            ) : (
                                <span className="font-bold fs16 ml10 mr10 overflow-hidden" title={company?.name}>
                                    {company?.name}
                                </span>
                            )}
                        </div>

                        <EditOutlined
                            className="mr20"
                            title="修改"
                            onClick={() => {
                                setEdit(!edit);
                            }}
                        />

                        <span className="error">供货商ID:{company?.id}</span>

                        <CopyOutlined onClick={handleCopy} title="复制" className="ml3" />
                    </div>
                </div>
            </Spin>
        </Panel>
    );
};

export default observer(SupplierInfo);
